import {isClient} from "@/utils/isTerminal";


let matchStr = window.navigator.userAgent.match(/NurseFuel\/\S+\((\S*)\)/i);
// alert(window.navigator.userAgent)

let nurseFuelVar ={};

if(Array.isArray(matchStr) && matchStr.length>1){
    let strVar = matchStr[1];

    let strVarArr = strVar.split('&');

    for (let i =0;i<strVarArr.length;i++){
        let valArr =  strVarArr[i].split('=')
        nurseFuelVar[valArr[0]] = valArr[1];
    }
}
export function getNurseFuelVar() {

    if(!isClient){return {}}
    return nurseFuelVar
}


